import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../utils/checkout';
export function FinalCTA() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-66" data-mp="3mtrzkafbyh2x">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-67" data-mp="3mt8rrmje992m">
        <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-68" data-mp="3rs3aypl9wzn9">
          La decisión es tuya.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-muted sm:text-center" data-id="element-69" data-mp="3dv6n8x0gbyal">
          <p data-id="element-70" data-mp="33uw9nbai8ouw">
            Puedes seguir como hasta ahora. Preparando clases desde cero cada semana. Improvisando cuando el
            plan falla. Dudando si está bien alineado con LOMLOE. Llegando al patio sin saber si lo que vas
            a hacer es lo correcto para ese grupo.
          </p>
          <p data-id="element-71" data-mp="172m7u14yid46">
            O puedes llegar el martes con todo listo. Con la sesión elegida. El objetivo claro. La variante
            flash pensada. El control total del grupo en 7 días.
          </p>
          <p className="font-semibold text-ink" data-id="element-72" data-mp="l9k211kkozqh">Listas de sesiones. 11 tomos. 4 bonos. 7 días de garantía.</p>
          <p className="font-semibold text-flash" data-id="element-73" data-mp="z0p3m97i423g">El precio de un café al día. El valor de un trimestre entero transformado.</p>
        </div>

        <m.a href={CHECKOUT_URL} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="group mx-auto mt-8 flex max-w-sm flex-col items-center gap-3 rounded-2xl border border-slate-200 bg-bg-secondary p-6 text-center shadow-card transition-colors hover:border-orange/40" data-id="element-74" data-mp="uzvj7pt9p5fb">
          <span className="font-heading text-sm font-bold uppercase tracking-wide text-muted" data-id="element-75" data-mp="bdh3e5oxjj8a">
            🎯 EF-FLASH: Sistema Completo
          </span>
          <span className="font-heading text-3xl font-extrabold text-ink" data-id="element-76" data-mp="1mrb5fiqwwq50">17,99€</span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-orange px-6 py-3 text-sm font-bold uppercase text-white transition-colors group-hover:bg-orange-hover" data-id="element-77" data-mp="kdmzoz2mdwin">
            Quiero EF-FLASH
            <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-78" data-mp="tdjpx54nr3ft" />
          </span>
          <span className="text-[11px] text-muted" data-id="element-79" data-mp="yblcw157fmwk">
            💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 7 días
          </span>
        </m.a>
      </div>
    </section>;
}